import { Typography, styled } from '@mui/material'

export const StyledComercialDescription = styled(Typography)(({ theme }) => ({
  background: theme.palette.primary.main,
  color: theme.palette.text.white,
  padding: theme.spacing(3),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
}))
